// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "form_signature".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "form_signature" table (1:1 with a DB row, on the wire). */
export const formSignatureAtomSchema = z.object({
    id: z.string(),
    submissionId: z.string(),
    signedByName: z.string().nullable(),
    signedAt: z.string().datetime().nullable(),
    signedIp: z.string().nullable(),
    signatureImageKey: z.string().nullable(),
    pdfKey: z.string().nullable(),
    pdfGenerationAttempts: z.number(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=formSignature.js.map